/**
 * authEvents — lightweight pub/sub for cross-cutting auth signals.
 * Allows apiService (outside React) to notify AuthProvider of a 401.
 */

const listeners = new Set();

export const authEvents = {
  /** Subscribe to the 'unauthorized' event. Returns an unsubscribe fn. */
  onUnauthorized(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },

  /** Dispatch the 'unauthorized' event (called from the 401 interceptor). */
  emitUnauthorized() {
    listeners.forEach((fn) => fn());
  },
};

export default authEvents;
